import React from 'react'

import Button from './button'

export type TAlert = {
  readonly title: string
  readonly description: string
  readonly buttonTitle: string
  readonly backButtonTitle?: string
  readonly isOpen: boolean
  readonly isError?: boolean
  readonly traceId?: string
  readonly onSubmit: () => void
  readonly onClose?: () => void
}

export default function Alert({
  title,
  description,
  buttonTitle,
  backButtonTitle,
  isOpen,
  isError,
  traceId,
  onSubmit,
  onClose,
}: TAlert) {
  return (
    <div>
      {isOpen && (
        <>
          <div className='fixed inset-0 z-50 flex items-center justify-center'>
            <div className='z-50 mx-5 w-full overflow-y-auto rounded-3xl bg-white shadow-lg md:w-1/2 xl:w-4/12'>
              <div className='flex flex-col gap-2 px-6 py-4 text-left'>
                <h1 className='text-lg font-semibold'>{title}</h1>
                <p className='text-sm font-light'>{description}</p>
                {traceId && (
                  <p className='text-xs font-light text-pop-gray-4'>Trace ID {traceId}</p>
                )}
                <div className='mt-3 flex w-full flex-row justify-center gap-4'>
                  <div className='flex w-full flex-row justify-around gap-4 xl:w-3/4'>
                    {!!backButtonTitle && (
                      <Button
                        id={buttonTitle}
                        name={buttonTitle}
                        variant='text'
                        onClick={onClose}
                        type='button'
                        aria-label={backButtonTitle ?? 'Kembali'}
                      >
                        {backButtonTitle ?? 'Kembali'}
                      </Button>
                    )}
                    {buttonTitle ? (
                      <Button
                        id={buttonTitle}
                        name={buttonTitle}
                        variant='contained'
                        onClick={onSubmit}
                        type='button'
                        color={isError ? 'error' : 'primary'}
                        aria-label={buttonTitle}
                      >
                        {buttonTitle}
                      </Button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fixed inset-0 z-40 bg-gray-500 opacity-75'></div>
        </>
      )}
    </div>
  )
}
